export default "__VITE_ASSET__fc2db94a__"